import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-provider-terms',
  templateUrl: './provider-terms.html',
  styleUrls: ['./provider-terms.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProviderTermsComponent {}
